import { StockItem } from './../../acumatica/EntityServices/StockItem.service';
import { CustomerSalesStatusList, CustomerSerivce } from './../../acumatica/EntityServices/Customer.service';
import { MayerFabricsService } from 'src/app/services/mayer-fabrics.service';
import { AlertDialog } from './../../common/alert-dialog/alert-dialog.component';
import { NoteEditorDialog } from './../../common/note-editor-dialog/note-editor-dialog.component';
import { WarehouseService } from '../../acumatica/EntityServices/Warehouse.service';
import { UpToDateBuildService } from './../../services/up-to-date-build.service';
import { WMSService } from './../../services/wms.service';
import { PurchaseReceiptService } from '../../acumatica/EntityServices/PurchaseReceipt.service';
import { TransferDetail, TransferService } from '../../acumatica/EntityServices/TransferOrder.service';
import { ShipmentService, ShipmentDetailAllocation, Shipment } from '../../acumatica/EntityServices/Shipment.service';
import { StockItemService } from '../../acumatica/EntityServices/StockItem.service';
import { SalesOrder, SalesOrderService, SalesOrderDetail, SalesOrderShipment } from '../../acumatica/EntityServices/SalesOrder.service';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, ChangeDetectorRef, ViewChild, TemplateRef, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { AcumaticaService } from '../../acumatica/acumatica.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { InventorySummaryDetail, InventorySummaryInquiryService } from '../../acumatica/EntityServices/InventorySummaryInquiry.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Adjustment, AdjustmentDetail, AdjustmentService } from '../../acumatica/EntityServices/Adjustment.service';
import { Transfer } from '../../acumatica/EntityServices/TransferOrder.service';
import { environment } from 'src/environments/environment';
import { LogService } from '../../services/logging.service';
import { Customer } from 'src/app/acumatica/EntityServices/Customer.service';
import { CountryService } from 'src/app/acumatica/EntityServices/Country.service';
import { ApplicationScreen } from 'src/app/application-navigator/application-screen';
import { InventoryIDSelectorComponent } from 'src/app/common/inventory-id-selector/inventory-id-selector.component';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { SignalrService } from 'src/app/services/signalr.service';

@Component({
  selector: 'app-developer',
  templateUrl: './developer.component.html',
  styleUrls: ['./developer.component.css']
})
export class DeveloperComponent extends ApplicationScreen implements OnInit, OnDestroy {
  pageTitle = "Developer / Debugging";
  environment = environment; // make environment variables available to template
  window = window;
  @ViewChild('createTestSOType') createTestSODialog!: TemplateRef<any>;
  @ViewChild('forTest') forTest!: TemplateRef<any>;
  public inventoryID: string | null = 'CA-001';

  public onCustomerChange(customer: Customer | null) { this.customer = customer; }
  public customer: Customer | null = null;
  public order: SalesOrder = new SalesOrder();

  get devsonbr() { return localStorage.getItem('DEV-SO-NBR'); }
  get devshnbr() { return localStorage.getItem('DEV-SH-NBR'); }

  get virtualKeyboardAPISupport(): boolean { return 'virtualKeyboard' in navigator }

  // @ViewChild('qtyInput') element!: HTMLInputElement;
  // hideVirtualKeyboard() {
  //   setTimeout(() => (<any>navigator).virtualKeyboard.hide());

  //   let element = (<any>this.element).nativeElement;
  //   element.setAttribute('readonly', 'readonly'); // force keyboard to hide on input field
  //   element.setAttribute('disabled', 'true'); // force keyboard to hide on textarea field
  //   setTimeout(() => {
  //     element.blur(); // actually close the keyboard
  //     element.removeAttribute('readonly');
  //     element.removeAttribute('disabled');
  //     element.focus();
  //   });
  // }

  public innerWidth: any;
  public innerHeight: any;
  get networkTestingButton() { return 'API Testing is ' + (this.networkTestingState ? 'On' : 'Off'); }
  private networkTestingState: boolean = false;

  soOrderType = new FormControl(null, [Validators.required]);
  cameraTestForm = new FormGroup({
    image: new FormControl(null, [Validators.required])
  });

  createSOUnitTestFormGroup!: FormGroup;

  testVal: number | null = 10;

  SOUnitTests: TestSalesOrderInterface[] = [
    {
      description: "Multi-Allowance Issue",
      factory: () => {
        return new TestSalesOrderBuilder([
          { InventoryID: "WC976-024", WarehouseID: "01", OrderQty: 3 },
          { InventoryID: "SE-026", WarehouseID: "01", OrderQty: 2 },
        ]);
      }
    },

    {
      description: "Supplies",
      factory: () => {
        // TODO: ensure focus is set to Location field on subsequent lines when needed
        return new TestSalesOrderBuilder([
          { InventoryID: "PFFS", WarehouseID: "01", OrderQty: 12 },
          { InventoryID: "WEL5", WarehouseID: "01", OrderQty: 1 },
          { InventoryID: "CA-001", WarehouseID: "01", OrderQty: 5 },
          { InventoryID: "PBF", WarehouseID: "01", OrderQty: 1 },
        ]);
      }
    },

    {
      description: "Picking Order",
      factory: () => {
        return new TestSalesOrderBuilder([
          { InventoryID: "SW-053", WarehouseID: "01", OrderQty: 32 },
          { InventoryID: "MG-003", WarehouseID: "01", OrderQty: 21 },
          { InventoryID: "SW-053", WarehouseID: "01", OrderQty: 18 },
          { InventoryID: "MG-003", WarehouseID: "01", OrderQty: 16 },
        ]);
      }
    },

    {
      description: "Multi-Cut",
      factory: () => {
        return new TestSalesOrderBuilder([
          { InventoryID: "DU-006", WarehouseID: "01", OrderQty: 19 },
          { InventoryID: "CA-001", WarehouseID: "01", OrderQty: 4 },
          { InventoryID: "CA-001", WarehouseID: "01", OrderQty: 5 },
          { InventoryID: "CA-001", WarehouseID: "01", OrderQty: 6 },
        ]);
      }
    },

    {
      description: "2-Line Yardage",
      factory: () => {
        return new TestSalesOrderBuilder([
          { InventoryID: "459-001", WarehouseID: "01", OrderQty: 5 },
          { InventoryID: "621-016", WarehouseID: "01", OrderQty: 12 },
        ]);
      }
    },

    {
      description: "1-Line Yardage",
      factory: () => {
        return new TestSalesOrderBuilder([
          { InventoryID: "CA-006", WarehouseID: "01", OrderQty: 5 },
        ]);
      }
    },

    {
      description: "Multiple Locations, Same Lot",
      factory: () => {
        return new TestSalesOrderBuilder([
          { InventoryID: "MD-004", WarehouseID: "01", OrderQty: 5 },
        ]);
      }
    },

    {
      description: "Sample Cards",
      factory: () => {
        return new TestSalesOrderBuilder([
          { InventoryID: "100CD", WarehouseID: "03", OrderQty: 1 },
          { InventoryID: "160CL", WarehouseID: "03", OrderQty: 1 },
        ]);
      }
    },

    {
      description: "Tag Set",
      factory: () => {
        return new TestSalesOrderBuilder([
          { InventoryID: "MLCH-009", WarehouseID: "03", OrderQty: 1 },
          { InventoryID: "MLLA-001", WarehouseID: "03", OrderQty: 1 },
        ]);
      }
    },

    {
      description: "Multiple Cuts",
      factory: () => {
        return new TestSalesOrderBuilder([
          { InventoryID: "CA-031", WarehouseID: "01", OrderQty: 3 },
          { InventoryID: "CA-031", WarehouseID: "01", OrderQty: 4 },
        ]);
      }
    },

    {
      description: "Memo Samples",
      factory: () => {
        return new TestSalesOrderBuilder([
          { InventoryID: "MMU-001", WarehouseID: "03", OrderQty: 1 },
          // { InventoryID: "MDU-006", WarehouseID: "03", OrderQty: 1 },
        ], "9");
      }
    },

    {
      description: "Outlet Item",
      factory: () => {
        return new TestSalesOrderBuilder([
          { InventoryID: "WC741-011", WarehouseID: "09", OrderQty: 5 },
        ], "9");
      }
    },

    {
      description: "EOR, FLA, and FUL",
      factory: () => {
        return new TestSalesOrderBuilder([
          { InventoryID: "CA-031", WarehouseID: "01", OrderQty: 13.5, note: "EOR" },
          // { InventoryID: "DU-002", WarehouseID: "01", OrderQty: 5, note: "Flaw" },
          { InventoryID: "DU-006", WarehouseID: "01", OrderQty: 30, note: "Ship Full Roll" },
        ], "910891");
      }
    },

    {
      description: "Full Rolls",
      factory: () => {
        return new TestSalesOrderBuilder([
          { InventoryID: "DU-006", WarehouseID: "01", OrderQty: 90, note: "Ship Full Roll" },
        ], "9");
      }
    },

    {
      description: "Label Test",
      factory: () => {
        return new TestSalesOrderBuilder([
          { InventoryID: "CA-001", WarehouseID: "01", OrderQty: 8 },
          { InventoryID: "CA-001", WarehouseID: "01", OrderQty: 10 },
          // { InventoryID: "M", LineDescription: "This is a line note item", OrderQty: 0 }
        ], "910891");
      }
    },

    {
      description: "Multiple Items",
      factory: () => {
        return new TestSalesOrderBuilder([
          { InventoryID: "CA-001", WarehouseID: "01", OrderQty: 30, note: "Ship x1 full roll" },
          { InventoryID: "CA-002", WarehouseID: "01", OrderQty: 20 },
          { InventoryID: "CA-004", WarehouseID: "01", OrderQty: 15 },
        ])
      }
    },

    {
      description: "Single Item - Pieced",
      factory: () => {
        return new TestSalesOrderBuilder([
          { InventoryID: "CA-002", WarehouseID: "01", OrderQty: 30 }
        ]);
      }
    },

    {
      description: "Multiple Warehouses",
      factory: () => {
        return new TestSalesOrderBuilder([
          // 01 standard items
          { InventoryID: "CA-001", WarehouseID: "01", OrderQty: 30, note: "Ship x1 full roll" },
          { InventoryID: "MR-014", WarehouseID: "01", OrderQty: 20 },
          // memo item
          { InventoryID: "M299-016", WarehouseID: "03", OrderQty: 1 },
          // inactive vendor -- outlet center item
          { InventoryID: "WC741-001", WarehouseID: "09", OrderQty: 20 }
        ]);
      }
    }
  ]

  constructor(
    private http: HttpClient,
    private router: Router,
    private dialog: MatDialog,
    private changeDetectorRef: ChangeDetectorRef,
    private acumatica: AcumaticaService,
    private mayerfabrics: MayerFabricsService,
    private salesOrders: SalesOrderService,
    private stockItems: StockItemService,
    private shipments: ShipmentService,
    private inventoryInquiry: InventorySummaryInquiryService,
    private adjustments: AdjustmentService,
    private transfers: TransferService,
    private purchaseReceipts: PurchaseReceiptService,
    private wms: WMSService,
    public logger: LogService,
    private upToDateBuildService: UpToDateBuildService,
    private warehouses: WarehouseService,
    private customers: CustomerSerivce,
    private countries: CountryService,
    private snackBar: MatSnackBar,
    // private signalRService: SignalrService,
  ) {
    super();

    (<any>navigator).virtualKeyboard.overlaysContent = true;

    this.createSOUnitTestFormGroup = new FormGroup({
      SOUnitTestIndex: new FormControl()
    });

    // this.customers.get('56700').subscribe(customer => {
    //   console.warn(customer);
    //   this.customer = customer
    // });
  }
  ngOnDestroy(): void {

  }

  ngOnInit(): void {
    this.updateWindowSize();

    // this.signalRService.onConnectionError.subscribe(err => {
    //   this.dialog.open(AlertDialog, { data: { message: err.toString() } });
    // });

    // this.signalRService.startConnection();
    // this.signalRService.onBroadcastMessage.subscribe(message => {
    //   this.dialog.open(AlertDialog, { data: { message: message } });
    // })
    // this.signalRService.addBroadcastMessageListener();

    // this.window.setTimeout(() => {
    //   this.itemSelector.inventoryID = 'caressa';
    //   this.itemSelector.onEnter();
    // }, 500);
  }
  @ViewChild('itemSelector') itemSelector!: InventoryIDSelectorComponent;

  public info: string = '<table>';
  counter: number = 0;
  onLotSerialNbrEntered(lotNbr: string | number | null) {
    this.info += (++this.counter) + ". " + lotNbr + "\n";
  }

  onLotTEST0(event: Event) {
    console.warn(event);
    let el = <HTMLInputElement>event.target;
    this.info += (++this.counter) + ". " + el.value + "\n";
    el.value = '';
    event.preventDefault();
  }

  onLotTEST1(event: Event) {
    console.warn(event);
    let el = <HTMLInputElement>event.target;
    this.info += (++this.counter) + ". " + el.value + "\n";
    el.value = '';
    event.preventDefault();
  }

  onLotTEST2(value: string, el: HTMLInputElement) {
    console.warn(value, el);
    this.info += (++this.counter) + ". " + el.value + "\n";
    el.value = '';
  }

  get connectionState() {
    // return this.signalRService.connectionState;
    return null;
  }

  updateWindowSize() { this.innerWidth = window.innerWidth; this.innerHeight = window.innerHeight; }
  @HostListener('window:resize', ['$event']) onResize(event: any) { this.updateWindowSize(); }

  item?: StockItem;
  gotItem(item?: StockItem) { this.item = item; }

  public QuickTestOutput?: string;

  do_the_thing() {
    this.logTest();
  }

  do_the_error() {
    // this.stockItems.get('https://mayerfabrics.com/item/MU').subscribe(item => {
    //   console.log(item);
    // })
  }

  UpdateShipmentFromLogData() {
    this.dialog.open(NoteEditorDialog, {
      data: {
        label: 'JSON Shipment Data'
      }
    }).afterClosed().subscribe(response => {
      if (!response) return;
      let shipment: Shipment = JSON.parse(response);

      delete (shipment.__id);
      shipment.Details.forEach(detail => {
        delete (detail.__id);
        detail.SuggestedPickingSource = null;
        detail.Allocations.forEach(alloc => {
          delete (alloc.__id);
        })
      });

      console.log(shipment);
      console.log(JSON.stringify(shipment));
      this.shipments.completeShipmentPicking(shipment, undefined, true, status => {
        console.log(status.toString());
      }).subscribe(() => {
        this.dialog.open(AlertDialog, { data: { message: 'Shipment has been updated', buttonText: 'OK' } });
      });
    })
  }

  deletePrevTest() {
    let deleteSalesOrder = () => {
      localStorage.removeItem('DEV-SH-NBR');
      this.acumatica.delete('SalesOrder', ['SO', this.devsonbr!], {
        loader: "Deleting Sales Order\n" + this.devsonbr
      }).subscribe(() => {
        localStorage.removeItem('DEV-SO-NBR');
      }, error => {
        localStorage.removeItem('DEV-SO-NBR');
      });
    }

    let deleteShipment = () => {
      this.acumatica.delete('Shipment', [this.devshnbr!], {
        loader: "Deleting Shipment\n" + this.devshnbr
      }).subscribe(deleteSalesOrder, deleteSalesOrder);
    }

    this.shipments.get(this.devshnbr!).subscribe(shipment => {
      if (shipment.Status == 'Confirmed') {
        this.acumatica.action('Shipment', 'CorrectShipment', shipment, {}, { message: "Correcting Shipment" })
          .subscribe(deleteShipment)
      } else {
        deleteShipment();
      }
    }, deleteShipment)
  }

  get navigateToTest(): boolean {
    return localStorage.getItem('navigate-to-unit-test') != undefined;
  }
  set navigateToTest(value: boolean) {
    if (value) localStorage.setItem('navigate-to-unit-test', 'yes');
    if (!value) localStorage.removeItem('navigate-to-unit-test');
  }

  promptCreateTestSO() {
    this.dialog.open(this.createTestSODialog, {
      width: '95vw'
    }).afterClosed().subscribe(response => {
      if (!response) return;
      let unitTestIndex = this.createSOUnitTestFormGroup.get('SOUnitTestIndex')!.value;
      if (unitTestIndex == null) return;

      this.createPickingTestCase(unitTestIndex).then(shipment => {
        if (this.navigateToTest) {
          this.router.navigate(['/picking', shipment.ShipmentNbr]);
        }
      })
    });
  }

  createPickingTestCase(SOTemplate: number | SalesOrder, openSalesOrder: boolean = false, openShipment: boolean = false): Promise<SalesOrderShipment> {
    return new Promise<SalesOrderShipment>(resolver => {
      let so: SalesOrder;
      if (typeof SOTemplate == 'number') so = this.SOUnitTests[SOTemplate].factory();
      else so = SOTemplate;

      this.acumatica.put('SalesOrder', so, {
        loader: { message: "Creating Sales Order" }
      }).subscribe(so => {
        localStorage.setItem('DEV-SO-NBR', so.OrderNbr.value);

        this.shipments.createShipment(so.OrderType.value, so.OrderNbr.value).subscribe(SOShipment => {
          localStorage.setItem('DEV-SH-NBR', SOShipment.ShipmentNbr);

          if (openSalesOrder)
            window.open("https://erp.nhook.com:10443/MPF21R2/?ScreenId=SO301000&OrderType=SO&OrderNbr=" + so.OrderNbr.value, "_salesorder");

          if (openShipment)
            window.open("https://erp.nhook.com:10443/MPF21R2/?ScreenId=SO302000&ShipmentNbr=" + SOShipment.ShipmentNbr, "_shipment");

          resolver(SOShipment);
        });
      });
    });
  }

  devTest_AddEndOfRollOverage() {
    let SOOrderType = "SO";
    let SOOrderNbr = "SO0967253";

    // Create a Shipment for the Sales Order
    this.shipments.createShipment(SOOrderType, SOOrderNbr).subscribe(orderShipment => {
      this.shipments.get(orderShipment.ShipmentNbr).subscribe(shipment => {

        // add picking details for standard shipment line
        shipment.Details[0].Allocations.push(
          Object.assign(new ShipmentDetailAllocation(), {
            LocationID: "208D04",
            LotSerialNbr: "217031F4",
            Qty: 24
          })
        );

        console.warn(shipment.encode());
      });
    });
  }

  updateSOTest() {
    this.salesOrders.get('SO', 'SO0974189').subscribe(so => {
      this.salesOrders.put(so, {
        expand: 'Details'
      }).subscribe(updated_so => {
        console.warn(updated_so);
      })
    })
  }

  get cameraImage() { return this.cameraTestForm.get('image')!; }

  reverseAdjustment() {
    // create new Adjustment document
    let adjustment = new Adjustment();
    adjustment.ExternalRef = 'DEV-REVERSAL';
    adjustment.Description = 'Undo Adjustment created by Shipment Release';
    adjustment.Details = [
      Object.assign(new AdjustmentDetail(), {
        InventoryID: "DU-006",
        WarehouseID: "01",
        LocationID: "201B09",
        Quantity: -1,
        LotSerialNbr: "F1303995034",
        ReasonCode: "INPHYS",
      })
    ];

    this.adjustments.put(adjustment).subscribe(putAdj => {
      console.log("Created adjustment: " + putAdj.ReferenceNbr);

      this.adjustments.Release(adjustment, { message: "Releasing Adjustment" }).subscribe(() => {
        console.log("Adjustment has been released");
      });
    })
  }

  adjustmentsTest() {
    // get existing Adjustment document
    this.adjustments.get("00028496", {
      expand: "Details"
    }).subscribe(adjustment => {
      console.warn(adjustment);
    });

    // create new Adjustment document
    let adjustment = new Adjustment();
    adjustment.ExternalRef = 'ABC123';
    adjustment.Description = 'This is a test';
    adjustment.Details = [
      Object.assign(new AdjustmentDetail(), {
        InventoryID: "CA-001",
        Warehouse: "01",
        Location: "201C05",
        Quantity: 1,
        LotSerialNbr: "ABC123",
        ReasonCode: "INPHYS",
      })
    ];

    this.adjustments.put(adjustment).subscribe(putAdj => {
      console.log("Created adjustment: " + putAdj.ReferenceNbr);

      // this.adjustments.Release(adjustment).subscribe(() => {
      //   console.log("Adjustment has been released");
      // });
    })
  }

  addShippedItemTest() {
    this.salesOrders.addShippedItem('SO', this.devsonbr!, 'MU-001', '01', 1, true, "Testing")
      .subscribe(so => {
        console.log(so);
      });
  }

  concurrentAddItemsTest() {
    let OrderNbr = this.devsonbr!;
    this.salesOrders.get('SO', OrderNbr).subscribe(so => {
      this.salesOrders.addShippedItem('SO', OrderNbr, "CA-002", '01', 2, false, null).subscribe(() => { });
      this.salesOrders.addShippedItem('SO', OrderNbr, "CA-003", '01', 3, false, null).subscribe(() => { });
      this.salesOrders.addShippedItem('SO', OrderNbr, "CA-004", '01', 4, false, null).subscribe(() => { });
    })
    let me = this;

    let SOs: { [key: string]: Promise<SalesOrder> } = {};
    let getSO = function (OrderType: string, OrderNbr: string): Promise<SalesOrder> {
      let SOkey = OrderType + '/' + OrderNbr;
      if (SOs[SOkey] === undefined) {
        SOs[SOkey] = new Promise<SalesOrder>((resolve, reject) => {
          console.warn('fetching');
          me.salesOrders.get(OrderType, OrderNbr, {
            expand: 'Details',
            loader: "Getting Sales Order"
          }).subscribe(resolve, reject)
        });
      }

      return SOs[SOkey];
    }

    getSO('SO', this.devsonbr!).then(so => {
      console.log(1, so);
    })

    getSO('SO', this.devsonbr!).then(so => {
      console.log(2, so);
    })

    setTimeout(() => {
      getSO('SO', this.devsonbr!).then(so => {
        console.log(3, so);
      })
    }, 1000)
  }

  transferOrderTest() {
    // this.transfers.get('TR0206683', {
    //   expand: "Details"
    // }).subscribe(transfer => {
    //   console.log(transfer);
    // });

    let transfer = new Transfer();
    transfer.FromWarehouseID = '01';
    transfer.ToWarehouseID = '01';
    transfer.ExternalRef = 'ABC123';
    transfer.Description = 'Testing';

    let line = new TransferDetail();
    line.InventoryID = "CA-001";
    line.FromLocationID = "201C05";
    line.ToLocationID = "201F08";
    line.Qty = 2.5;
    line.UOM = "YD";
    line.LotSerialNbr = "F110121020";

    transfer.Details.push(line);

    this.transfers.put(transfer).subscribe(transfer => {
      console.warn('Created ' + transfer.ReferenceNbr, transfer);
    })
  }

  private networkTestingHandle: any;
  troubleshootNetworkAPI() {
    this.networkTestingState = !this.networkTestingState;
    if (this.networkTestingState) {
      this.doAPITest();
    } else {
      if (this.networkTestingHandle) clearTimeout(this.networkTestingHandle);
    }
  }

  doAPITest() {
    this.stockItems.get('CA-001').subscribe(
      item => {
        console.log(item);
        if (this.networkTestingState) this.networkTestingHandle = setTimeout(() => {
          this.doAPITest();
        }, 5000);
      },
      error => {
        this.networkTestingState = false;
        clearTimeout(this.networkTestingHandle);
        console.error(error);
      });
  }

  logTest() {
    this.logger.log(this.acumatica.username, [true, { a: 1, b: 2 }], '{extra data}');
  }

  shipmentSuspendTest() {
    this.shipments.get('SH0262500').subscribe(shipment => {
      let detail = shipment.Details[0];
      let pickLocation = '201F08';
      let pickLotSerNbr = 'F54080321';

      this.inventoryInquiry.get(detail.InventoryID).subscribe(inventory => {
        let pickSource = inventory.Results.find((result: InventorySummaryDetail) => {
          return result.LocationID == pickLocation && result.LotSerialNbr == pickLotSerNbr;
        });

        let alloc = new ShipmentDetailAllocation();
        alloc.LocationID = pickLocation;
        alloc.LotSerialNbr = pickLotSerNbr;
        alloc.InventoryID = detail.InventoryID;
        alloc.PickSource = pickSource;
        alloc.Qty = 30;
      });

      console.log(JSON.stringify(shipment));
    });
  }

  customerSelectorChange(customer: Customer | null) {
    console.warn(customer);
  }

  public keyInfo: string = '';
  showKeypress(event: KeyboardEvent) {
    this.keyInfo = 'key: ' + event.key + ', code: ' + event.code + ', detail: ' + event.detail
  }

  barcodeValidation(e: any) {
    console.warn('barcodeValidation', e);
  }

  processScannedBarcode(e: any) {
    console.warn('processScannedBarcode', e);
  }

  // outputScanData?: any;
  // private scanInputs: KeyboardEvent[] = [];
  // @HostListener('document:keypress', ['$event'])
  // devDocumentKeyPressEvent(event: KeyboardEvent) {
  //   console.warn(event);
  //   this.scanInputs.push(event);

  //   if (this.outputScanData) clearTimeout(this.outputScanData);
  //   this.outputScanData = setTimeout(() => {
  //     let table = '<table class="dev"><thead><tr><td>Key</td><td>Code</td><td>Which</td><td>keyCode</td><td>charCode</td></tr></thead>';
  //     this.scanInputs.forEach(e => table += `<tr>
  //       <td>${e.key}</td>
  //       <td>${e.code}</td>
  //       <td>${e.which.toString()}</td>
  //       <td>${e.keyCode.toString()}</td>
  //       <td>${e.charCode.toString()}</td>
  //     </tr>`);
  //     table += '</table>';
  //     this.scanDebugInfo = table;
  //     this.scanInputs = [];
  //   }, 500);
  // }
}

interface TestSalesOrderInterface {
  description: string,
  factory: () => SalesOrder
}

class TestSalesOrderBuilder extends SalesOrder {
  constructor(
    items: any[],
    CustomerID: string = "9",
    OrderType: string = "SO"
  ) {
    super();
    this.OrderType = OrderType;
    this.CustomerID = CustomerID;
    this.Details = [];
    items.forEach(item => this.addItem(item));
  }

  addItem(item: any) {
    this.Details?.push(Object.assign(new SalesOrderDetail(), item));
  }
}
